module.exports = __webpack_public_path__ + "13ba2a94a1370046c658f017a57a815a.jpg";